module.exports = __webpack_public_path__ + "static/media/0_2019_10_18.b171819c.jpg";